import { ReactNode, useRef, useEffect, useState } from 'react'

//import IconStart from '~/components/icons/IconStar'
import GalleryArrow from '~/components/icons/IconGalleryArrow'

// For product testimonial
// function Testimonial({ name, body, ratings }) {
//   return (
//     <>
//       <div className="flex gap-x-1">
//         {Array(5)
//           .fill(null)
//           .map((_x, i) => (
//             <IconStart active={i < ratings} key={i} />
//           ))}
//       </div>
//       <p className="text-sm mt-8 opacity-70 leading-6">{body}</p>
//       <p className="mt-6 text-sm font-medium">{name}</p>
//     </>
//   )
// }
//
type Props = {
  children: ReactNode
  numberOfItems: number
}

export default function TestimonialsSlider({ children, numberOfItems }: Props) {
  const containerRef = useRef(null)
  const [scrollCount, setScrollCount] = useState(0)

  const [innerWidth, setInnerWidth] = useState(
    containerRef.current?.offsetWidth || 0
  )

  const updateInnerWidth = () =>
    setInnerWidth(containerRef.current?.offsetWidth)

  useEffect(() => {
    setInnerWidth(containerRef.current?.offsetWidth)
    window.addEventListener('resize', updateInnerWidth)

    return () => window.removeEventListener('resize', updateInnerWidth)
  }, [])

  const onClick = (num: number) => () => {
    const isRight = num === 1

    const newScrollCount = isRight
      ? scrollCount + innerWidth
      : scrollCount - innerWidth

    if (!isRight && scrollCount === 0) return
    if (isRight && innerWidth * numberOfItems <= newScrollCount) return

    containerRef.current?.scrollTo({
      left: newScrollCount,
      behavior: 'smooth'
    })

    setScrollCount(newScrollCount)
  }

  const showArrow = numberOfItems > 1

  return (
    <div className="text-white max-w-7xl mx-auto">
      <div className="relative">
        <div>
          <div
            className="review-cards flex flex-nowrap overflow-x-scroll"
            ref={containerRef}
          >
            {children}
          </div>

          <style jsx>{`
            .review-cards {
              scrollbar-width: none;
              scrollbar-color: #f4f2eb;
            }
            .review-cards::-webkit-scrollbar {
              display: none;
              width: 0px;
            }
            .review-cards::-webkit-scrollbar-track {
              background: #f4f2eb;
            }
            .review-cards::-webkit-scrollbar-thumb {
              background: #f4f2eb;
            }
          `}</style>
        </div>
        <div
          onClick={onClick(-1)}
          className={`cursor-pointer absolute top-1/3 left-0 hidden ${
            showArrow && 'md:block'
          }`}
          hidden={numberOfItems <= 1}
        >
          <GalleryArrow direction="left" darkTheme />
        </div>
        <div
          onClick={onClick(1)}
          className={`cursor-pointer absolute top-1/3 right-0 hidden ${
            showArrow && 'md:block'
          }`}
        >
          <GalleryArrow direction="right" darkTheme />
        </div>
      </div>
    </div>
  )
}
